<template>
    <div class="startwrap">
        <template  v-if="sessionStorage.isToBrowser=='1'">
            <div class="enter">
                <div class="toBrowser">
                    <p v-html="$t('start.toBrowser')"></p>         
                </div>
                <div class="browser">
                    <div>{{$t('start.example')}}</div>
                    <img src="../assets/img/safari.png" alt="">
                    <img src="../assets/img/chrome.png" alt="">
                </div>
            </div>
        </template> 
        <div class="enter" v-else>
            <div class="startText">
                <p v-html="$t('start.startText')"></p>         
            </div>
            <div class="startButton" @click="jumpLoading">{{$t('start.startButton')}}</div>
        </div>
        <template v-if="sessionStorage.isToBrowser=='1'"></template>
        <div v-else class="selLang" @click="$router.push('/language')">
            <img src="../assets/img/set.png" alt="">
        </div>
        <!-- 黑色半透明背景 -->
        <div v-show="isTipShow" class="overlay">
        </div> 
        <div v-if="isTipShow" class="tips">
            <div class="tips_font">
                {{$t('start.openTip')}}
                <div class="tips_icon" @click="isTipShow=false;"></div>
            </div>
        </div>
        <div class="logo"></div>
    </div>
</template>

<script>
    export default {
        data(){
            return{
                isTipShow:false,
            }
        },
        mounted(){
            if(sessionStorage.isWebKit=='1'){
                this.judgeIsOpen();
            }
        },
        methods:{
            jumpLoading(){
                // let routeUrl = this.$router.resolve({
                //     path: "/game"
                // });
                // window.open(routeUrl.href);
                // window.location.href=routeUrl.href;
                // window.location.assign(routeUrl.href);
                this.$router.push('/game');
            },
            judgeIsOpen(){
                // DeviceMotionEvent.requestPermission().then(response => {});
                if (navigator.userAgent.indexOf('Safari') > -1) {
                    var ver = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
                    ver = parseInt(ver[1], 10);
                    if(ver==12){
                        this.isTipShow=true;
                    }else{
                    }
                }
            }
        },

    }
</script>

<style scoped>
    .startwrap{  
        height: 100%;
        background: url('../assets/img/start_bj.png') no-repeat ;
        background-size: cover;
    }

    .enter{
        background: url('../assets/img/enter_bj.png') no-repeat;
        background-size: cover;
        width: 624px;
        height: 450px;
        position: absolute;
        top: 200px;
        left: 50%;
        margin-left: -312px;   
    }

    /*文字*/
    .startText{
        margin-top: 84px;
        margin-bottom: 33px;
        font-weight:400;
        line-height:60px;
        font-size:40px; 
        color:rgba(255,255,255,1);
        text-align: center;
    }
    .startText>p{
        word-break: keep-all;   
    }
    /*开始按钮*/
    .startButton{
        background: url('../assets/img/button.png') no-repeat;
        background-size: 100% 100%;
        width: 254px;
        height: 107px;
        line-height: 107px;
        text-align: center;
        font-size: 48px;
        color: #fff;
        margin-bottom: 35px;
        margin-left: 188px;
    }
    /*开始按钮图片*/
    .startButton img{
        width: 254px;
        height: 107px;
        margin-bottom: 65px;
    }
    .selLang{
        width: 80px;
        height: 80px;
        position: fixed;
        right: 40px;
        top: 40px;
    }
    .selLang>img{
        width: 80px;
        height: 80px;
    }
    .overlay{
        width: 100%;
        height: 100vh;
        z-index: 19;
        position: fixed;
        background: #000;
        opacity: 0.3;
        top: 0;
        left: 0;
    }
    .tips{
        width:80%;
        height: 360px;
        position: fixed;
        top: 50%;
        z-index: 25;
        margin-top: -180px;
        margin-left: 10%;
        background-color: #D4B48C;
        border-radius: 30px;
        border: 3px solid #fff;
        display: flex;
        display: -webkit-flex;
        flex-direction: column;    
        justify-content: center;
        align-items: center;
    }
    .tips_font{
        width: 520px;
        height: 180px;
        color: #a4794c;
        font-size: 32px;
        text-align: center;
        position: relative;
    }
    .tips_icon{
        position: absolute;
        bottom: -90px;
        left:50%;
        margin-left: -140px; 
        width: 280px;
        height: 112px;
        background: url('../../static/img/close.png') no-repeat;
        background-size: 100% 100%;
    }
    .logo{
        width: 180px;
        height: 120px;
        position: fixed;
        left: 20px;
        top: 20px;
        background: url('../assets/img/logo.png') no-repeat;
        background-size: 100% 100%;
    }
    .toBrowser{
        margin-top: 60px;
        width: 90%;
        height: 240px;
        margin-left: 5%;
        font-weight:400;
        line-height:60px;
        font-size:40px; 
        color:rgba(255,255,255,1);
        text-align: center;
    }
    .toBrowser p{
        word-break: normal;   
    }
    .browser{
        width: 90%;
        height: 100px;
        margin-left: 5%;
        font-weight:400;
        line-height:100px;
        font-size:40px; 
        color:rgba(255,255,255,1);
    }
    .browser>div{
        height: 100px;
        float: left;
    }
    .browser>img{
        width: 100px;
        height: 100px;
        float: left;
    }
</style>


// WEBPACK FOOTER //
// src/components/Start.vue